export default __webpack_public_path__ + "static/media/s_warn.78ecbdd4.svg";